module.exports = __webpack_public_path__ + "static/media/lg.5fd4c338.woff";